import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import HeaderBrandRow from "./header-brand-row";
import styles from "./styles.m.css";
import { LoadingIndicatorComponent } from "../../atoms/loading-indicator";
import { checkAppSlug } from "../../utils/utils";
import IframeModal from "./iframe-modal";
// import SubscriptionLink from "./subscription-link";
import { Link } from "@quintype/components";
import Cookies from "universal-cookie";
import { fetchOneTabLogin } from "../../../api";
import { Vikataninterstitial } from "../ad-free";
import AudioMagazinePlayer from "../../pages/story/audiomagazine-story";
import { DeepBI } from "../../../integrations";
import GoogleAccountsInitializer from "./user-login/GoogleAccountsInitializer";
// import GiftBoxWidget from "../../pages/story/appinstall-gift";

const cookies = new Cookies();

class HeaderWithoutMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loginData: {},
      subscriptionLink: props.subscriptionLink,
      showPromo: true
    };
    this.handleCredentialResponse = this.handleCredentialResponse.bind(this);
    global.handleCredentialResponse = this.handleCredentialResponse;
  }

  componentDidMount() {
    global.userPromise.then(this.props.addUser);
  }

  handleCredentialResponse = response => {
    fetchOneTabLogin(response.credential)
      .then(response => {
        const current = new Date();
        const nextYear = new Date();
        nextYear.setFullYear(current.getFullYear() + 1);
        const resData = get(response, ["data"]);
        const resVuid = get(response, ["vuid"]);
        const email = get(response, ["data", "email"]);
        const guid = get(response, ["data", "guid"]);
        const evSS = get(response, ["data", "mainSession", "sessionId"]);
        const exSS = get(response, ["data", "secureSession", "sessionId"]);
        const hostname = window.location.hostname.replace(/^www\./, "");
        const domain =
          hostname.includes(".vikatan.com") || hostname === "vikatan.com" ? ".vikatan.com" : `.${hostname}`;
        cookies.set("ev-guid", guid, { path: "/", domain: domain, expires: nextYear });
        cookies.set("ev_ss", evSS, { path: "/", domain: domain, expires: nextYear });
        cookies.set("ex_ss", exSS, { path: "/", domain: domain, expires: nextYear });
        cookies.set("vuid", resVuid, { path: "/", domain: domain, expires: nextYear });
        global.localStorage.setItem("evolok:ev_session", JSON.stringify(resData));
        DeepBI.PingLoginevents("onetab_user_login", "success", email, resData);
        global.location.reload(false);
      })
      .catch(console.error);
  };

  render() {
    const { appStoreLinks, latestIssues, user, apiKey } = this.props;
    const loggedOutStat = get(user, ["loggedOut"], null);

    const { subscriptionLink } = this.state;
    if (checkAppSlug()) {
      return false;
    }
    return (
      <React.Fragment>
        {loggedOutStat === true ? (
          <GoogleAccountsInitializer loggedOut={loggedOutStat} onCredentialResponse={this.handleCredentialResponse} />
        ) : (
          <div />
        )}
        <LoadingIndicatorComponent />
        <Vikataninterstitial />
        <AudioMagazinePlayer />
        {/* <GiftBoxWidget /> */}
        <div className={`hidden-desktop ${styles["read-app-wrapper"]}`}>
          <Link
            aria-label={`Open APP`}
            href="https://onelink.to/79a4nr"
            className={`${styles["open-app"]} hidden-desktop`}
          >
            <span>Open App</span>
          </Link>
        </div>
        {!loggedOutStat && <IframeModal user={user} />}
        <div id="we-headerad" />
        <header className={styles["header"]} data-page-type={this.props.pageType}>
          <HeaderBrandRow
            user={this.props.user}
            appStoreLinks={appStoreLinks}
            latestIssues={latestIssues}
            subscriptionLink={subscriptionLink}
            vikatanHosts={this.props.vikatanHosts}
            apiKey={apiKey}
          />
        </header>
      </React.Fragment>
    );
  }
}

HeaderWithoutMenu.propTypes = {
  appStoreLinks: HeaderBrandRow.propTypes.appStoreLinks,
  latestIssues: HeaderBrandRow.propTypes.latestIssues,
  subscriptionLink: HeaderBrandRow.propTypes.subscriptionLink,
  pageType: PropTypes.string,
  addUser: PropTypes.func,
  user: PropTypes.object,
  apiKey: PropTypes.string,
  vikatanHosts: HeaderBrandRow.propTypes.vikatanHosts
};

function mapStateToProps(state) {
  const data = get(state, ["qt", "data", "header"]);
  const user = get(state, ["user"]);
  const vikatanHosts = get(state, ["qt", "config", "vikatanHosts"]);
  const pageType = get(state, ["qt", "pageType"]);
  return data ? { ...data, user, vikatanHosts, pageType } : {};
}

function mapDispatchToProps(dispatch) {
  return {
    addUser: function(user) {
      dispatch({
        type: "ADD_USER",
        user
      });
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HeaderWithoutMenu);
